// TermsAndConditionsPage.js
import React from 'react';
import './TermsAndConditions.css'

const TermsAndConditions = () => {
    return (
        <section className='terms-container'>
            <div className='terms-content'>
                <h2>Effective Date: 17-March-2025</h2>

                <p>Welcome to <strong>Vihana Matrimony</strong>, an online platform operated by Chellobee Technologies LLP. By accessing or using the Vihana Matrimony app, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.</p>

                <h3>1. Eligibility</h3>
                <ul>
                    <li>You must be at least <strong>18 years old</strong> to register, access, or use Vihana Matrimony.</li>
                    <li>By using the app, you confirm that you have the legal capacity to enter into a binding agreement under Indian laws.</li>
                    <li>You agree that your account is for personal use only and cannot be transferred or shared with others.</li>
                </ul>

                <h3>2. User Responsibilities</h3>
                <ul>
                    <li>You are responsible for the accuracy of the information provided in your profile.</li>
                    <li>You agree not to misuse the app for any illegal, harmful, or inappropriate purposes under the Indian Penal Code or any other applicable laws.</li>
                    <li>You must not upload or share content containing nudity, vulgarity, or any offensive material. Violating this rule will result in immediate termination of your account.</li>
                    <li>You agree to interact respectfully with other users and avoid any form of harassment, abuse, or threats.</li>
                </ul>

                <h3>3. Premium Membership</h3>
                <ul>
                    <li>Purchases of premium features are <strong>non-cancellable</strong> and <strong>non-refundable</strong> in accordance with Indian consumer protection laws.</li>
                    <li>Ensure that you review the details before purchasing any premium services.</li>
                    <li>Premium features may provide additional functionality but do not guarantee successful matches or interactions.</li>
                </ul>

                <h3>4. Content Submission</h3>
                <ul>
                    <li>Photos, audio, and videos submitted to your profile will be publicly accessible or visible to other users.</li>
                    <li>By submitting content, you grant Vihana Matrimony a <strong>non-exclusive, worldwide, royalty-free license</strong> to use, display, and distribute your content within the app.</li>
                    <li>You must ensure that any content submitted does not infringe on the rights of third parties under the <em>Indian Copyright Act, 1957</em>.</li>
                </ul>

                <h3>5. Authenticity of User Information</h3>
                <ul>
                    <li>Vihana Matrimony does not verify the authenticity of social media links or any other user-provided information.</li>
                    <li>Users are encouraged to exercise caution and due diligence when interacting with others.</li>
                    <li>Users are solely responsible for the accuracy and authenticity of the information shared on the platform.</li>
                </ul>

                <h3>6. Liability Disclaimer</h3>
                <ul>
                    <li>Chellobee Technologies LLP is <strong>not responsible</strong> for:
                        <ul>
                            <li>Any incidents, issues, or disputes that arise outside the app, including meetings or personal information shared between users.</li>
                            <li>Actions or consequences stemming from interactions initiated via the app.</li>
                        </ul>
                    </li>
                    <li>Users are advised to understand the other party better before engaging in activities like video calls or in-person meetings.</li>
                    <li>The company is not liable for any financial, emotional, or physical damages arising from the use of the app.</li>
                </ul>

                <h3>7. Privacy and Data</h3>
                <ul>
                    <li>Chat messages are <strong>not stored</strong> on Vihana Matrimony servers. Users should take backups if required.</li>
                    <li>This app is not a platform for sharing personal or sensitive information, including photos, videos, or chat messages. Users should exercise caution when communicating with others.</li>
                    <li>The company reserves the right to collect and use anonymized data for improving app functionality in accordance with the <em>Information Technology Act, 2000</em>, and related rules.</li>
                </ul>

                <h3>8. Matching and Preferences</h3>
                <ul>
                    <li>Vihana Matrimony does not guarantee personalized matches.</li>
                    <li>Match results are based solely on the preferences and profile information provided by users.</li>
                    <li>Users are encouraged to keep their preferences updated to improve match accuracy.</li>
                </ul>

                <h3>9. Verification Process</h3>
                <ul>
                    <li>Vihana Matrimony employs a <strong>selfie text code verification</strong> system for user identity confirmation.</li>
                    <li>The app does not conduct in-person or comprehensive background checks. Users are advised to remain vigilant and cautious during communications and interactions.</li>
                    <li>The company reserves the right to suspend accounts failing the verification process.</li>
                </ul>

                <h3>10. Prohibited Activities</h3>
                <ul>
                    <li>Misuse of the app, including but not limited to:
                        <ul>
                            <li>Impersonating others.</li>
                            <li>Harassing, threatening, or causing harm to other users.</li>
                            <li>Engaging in fraudulent or deceptive activities.</li>
                            <li>Promoting or soliciting business, products, or services without prior consent.</li>
                        </ul>
                        <strong>Will result in immediate account suspension or termination.</strong>
                    </li>
                </ul>

                <h3>11. Legal Considerations</h3>
                <ul>
                    <li>By using Vihana Matrimony, you agree to:
                        <ul>
                            <li>Comply with all applicable local, national, and international laws and regulations, including Indian laws such as the <em>Information Technology Act, 2000</em>.</li>
                            <li>Indemnify and hold harmless Chellobee Technologies LLP against any claims, damages, or liabilities arising from your use of the app.</li>
                        </ul>
                    </li>
                    <li>Any disputes shall be governed by the laws of India, and the courts of <strong>[Insert City]</strong>, India, shall have exclusive jurisdiction.</li>
                </ul>

                <h3>12. Safety Guidelines</h3>
                <ul>
                    <li>Take time to understand and verify users before sharing personal information or engaging in video calls.</li>
                    <li>Be cautious about sharing sensitive details such as financial information, home addresses, or work locations.</li>
                    <li>Report any suspicious or inappropriate behavior to Vihana Matrimony's support team immediately.</li>
                    <li>Users are encouraged to communicate within the app and avoid sharing personal contact details prematurely.</li>
                </ul>

                <h3>13. Community Standards</h3>
                <ul>
                    <li>Users are expected to maintain a respectful and courteous environment within the app.</li>
                    <li>Discriminatory behavior, hate speech, or offensive language will not be tolerated and will lead to account suspension.</li>
                </ul>

                <h3>14. Termination of Service</h3>
                <ul>
                    <li>Chellobee Technologies LLP reserves the right to terminate or suspend your account without prior notice for violations of these terms.</li>
                    <li>Accounts inactive for an extended period may be deactivated.</li>
                </ul>

                <h3>15. Changes to Terms</h3>
                <ul>
                    <li>These terms may be updated periodically. Users will be notified of significant changes through the app or via email.</li>
                    <li>Continued use of the app after changes to the terms constitutes acceptance of the updated terms.</li>
                </ul>

                <h3>16. Intellectual Property</h3>
                <ul>
                    <li>All intellectual property rights related to the app, including its design, functionality, and content, are owned by Chellobee Technologies LLP.</li>
                    <li>Users must not copy, distribute, or modify any part of the app without prior written permission.</li>
                </ul>

                <h3>17. Contact Information</h3>
                <p>If you have questions or need support, please contact us at <strong>support-vihanamatrimony@chellobee.com</strong>.</p>

                <p>By using Vihana Matrimony, you acknowledge that you have read, understood, and agree to these terms and conditions.</p>

            </div>
        </section>
    );
};

export default TermsAndConditions;
